import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { LocalForm } from 'react-redux-form';
import Header from '../Header';
import PropTypes from 'prop-types';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ' '
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    return status.payload.response;
  }
};

class Resetpassword extends Component {
  //const { intl } = props;
  static propTypes = {};
  // componentDidMount () {
  //   const { handle } = this.props.match.params;
  //   alert(handle);
  // }
  constructor(props) {
    super(props);
    const { intl } = this.props;
  }

  componentDidMount() {
    //console.log('this.props.match.params');
    //console.log(this.props.match.params[0]);
    const parasArray = this.props.match.params[0].split('/');
    console.log(parasArray);
    this.props.updatePassword(parasArray[0], parasArray[1]);
  }

  render() {
    return (
      <div className="preview page">
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          //subtitle={this.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />

        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm onSubmit={this.props.onSubmit}>
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%'
                  }}
                >
                  We had received your request. You will be notified by email
                  included temporary password.
                </label>
                <br />
                &nbsp;
                <br />
                &nbsp;
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <link to="login">
                    <button className="button" styel={{ padding: 20 }}>
                      <FormattedMessage
                        id="signin.button.name"
                        defaultMessage="Sign In"
                      />
                    </button>
                  </link>
                </div>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

Resetpassword.propTypes = {
  clickLoginHandler: PropTypes.func,
  updatePassword: PropTypes.func
};

export default injectIntl(Resetpassword);



// WEBPACK FOOTER //
// ./src/components/views/ResetPassword/index.js